import { render, staticRenderFns } from "./FormControlTemplatesTemplatesContentType.vue?vue&type=template&id=1f6fb4ec"
import script from "./FormControlTemplatesTemplatesContentType.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlTemplatesTemplatesContentType.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports